<template>
  
  <div>

    <v-toolbar flat color="white" v-if="showToolbar">
      <v-toolbar-title v-if="showTitle"> {{ title }} </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="showDownload" small round class="px-3" color="primary" dark @click="downloadExcel" title="Download Excel">
        Download
        <v-icon right dark>cloud_download</v-icon>
      </v-btn>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :hide-actions="hideActions"
      :hide-headers="hideHeaders"
      :items="mappedItems"
      :loading="loading"
    >
      <template slot="items" slot-scope="props">
        <tr is="row-data" :row="props.item" :headers="headers"></tr>
      </template>
      <template slot="footer" v-if="hasTotals">
        <tr class="total" is="row-data" :row="totals" :headers="headers"></tr>
      </template>
      <template slot="no-data" v-if="!mappedItems.length">
        <span> {{ statusMessage }} </span>
      </template>
    </v-data-table>

  </div>

</template>

<script>

  import isEmpty from 'lodash/isEmpty'
  import exportData from '../mixins/export-data'
  import DataRow from './DataTableRow'
  
  export default {
    
    components: {
      'row-data': DataRow
    },

    mixins: [ exportData ],

    props: {
      loading: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: ""
      },
      showTitle: {
        type: Boolean,
        default: false
      },
      sheetName: {
        type: String,
        default: "Sheet"
      },
      hideActions: {
        type: Boolean,
        default: false
      },
      hideHeaders: {
        type: Boolean,
        default: false
      },
      headers: {
        type: Array,
        default() {
          return []
        }
      },
      items: {
        type: Array,
        default() {
          return []
        }
      },
      totals: {
        type: Object,
        default() {
          return {}
        }
      },
      download: {
        type: Boolean,
        default: false
      },
      loadingMessage: {
        type: String,
        default: "Loading Data..."
      },
      emptyMessage: {
        type: String,
        default: "No data available"
      },
    },

    computed: {
      
      mappedItems() {

        let items = this.items.map(item => {
          
          let data = {}

          this.headers.forEach(header => {
            data[header.value] = item[header.value]
          })

          return data

        })

        return items

      },

      hasTotals () {
        return !isEmpty(this.totals)
      },

      exportHeaders() {
        return this.headers.map(item => {
          return item.text
        })
      },

      exportData() {

        let items = this.hasTotals ? [...this.mappedItems, this.totals] : this.mappedItems
        
        return items.map(item => {
          let data = []

          this.headers.forEach(header => {
            data.push(item[header.value])
          })

          return data
        })

      },

      showToolbar () {
        return ( this.showTitle && this.title ) || ( this.showDownload && this.sheetName )
      },

      showDownload () {
        return this.download && this.sheetName && this.exportData.length
      },

      statusMessage () {
        return this.loading ? this.loadingMessage : this.emptyMessage
      },

    },

    methods: {
      
      downloadExcel () {
        
        this.exportToExcel({
          headers: this.exportHeaders,
          data: this.exportData,
          name: this.sheetName,
          file: this.title
        })

      },

    },

  }

</script>

<style>

  /*this is global css*/
  table tr.total td {
    font-weight: bold !important;
  }

</style>
